import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxCollapseComponent } from './phx-collapse.component';
import { PhxCollapseItemComponent } from './collapse-item/phx-collapse-item.component';
import { PhxIconModule } from '../icon/icon.module';
import { PhxDividerModule } from '../divider/phx-divider.module';

@NgModule({
  declarations: [PhxCollapseComponent, PhxCollapseItemComponent],
  imports: [CommonModule, PhxIconModule, PhxDividerModule],
  exports: [PhxCollapseComponent, PhxCollapseItemComponent],
})
export class PhxCollapseModule {}
